import axios from "axios";
import { successHandling } from "../helpers/successHandling";
import { apiSelectedDeviceIdsHandler } from "../helpers/apiSelectedIdsHandler";

export const createAlarmPolicyDeploymentAPI = async (
  filterDevicesBy,
  selectedDevicesIds,
  alarmPolicyIds,
  t,
  successfulText
) => {
  let formData = new FormData();
  apiSelectedDeviceIdsHandler(formData, filterDevicesBy, selectedDevicesIds);
  alarmPolicyIds.forEach(i => {
    formData.append("alarm_policy_ids[]", i);
  });

  await axios({
    url: `/api/v2/alarm/deploy/assign-alarm-policies-to-devices`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return true;
};
